import { AppLink } from '@/shared/components/AppLink';
import { cn } from '@/shared/utils/cn';

interface SeoSearchLinksProps {
  tags: unknown | null;
  variant?: 'mobile' | 'desktop';
  className?: string;
  onTagClick?: (label: string) => void;
}

function parseTags(raw: unknown): Record<string, string> {
  if (!raw || typeof raw !== 'object') return {};
  return raw as Record<string, string>;
}

export function SeoSearchLinks({
  tags,
  variant = 'mobile',
  className,
  onTagClick,
}: SeoSearchLinksProps) {
  const tagMap = parseTags(tags);
  const entries = Object.entries(tagMap);

  if (entries.length === 0) return null;

  if (variant === 'desktop') {
    return (
      <div className={cn('px-1 py-2', className)}>
        <p className="font-primary text-sm leading-7 text-black break-words">
          <strong className="mr-2 font-bold whitespace-nowrap">Explore other designs</strong>
          {entries.map(([label, path]) => (
            <AppLink
              key={label}
              to={`/${path}`}
              className="mr-2 inline capitalize text-[var(--link-blue)] hover:underline whitespace-nowrap"
              onClick={() => onTagClick?.(label)}
            >
              {label}
            </AppLink>
          ))}
        </p>
      </div>
    );
  }

  return (
    <div
      className={cn(
        'overflow-x-auto whitespace-nowrap border-y border-[#e2e2e2] px-[15px] py-3.5 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden',
        className
      )}
    >
      <strong className="mr-[15px] inline text-sm font-semibold text-black">
        Explore other designs
      </strong>
      {entries.map(([label, path]) => (
        <span key={label} className="mr-[15px] inline">
          <AppLink
            to={`/${path}`}
            className="inline text-sm capitalize text-[var(--link-blue)] hover:underline"
            onClick={() => onTagClick?.(label)}
          >
            {label}
          </AppLink>
        </span>
      ))}
    </div>
  );
}
